import { Step } from 'react-joyride';

// The step targets are data-tour anchors published by @amsanalytics/react-shared-library
// (SliderGroup via VehicleFilterPanel, and VehicleListCard's deposit button). The deposit
// selector matches every card; document.querySelector resolves it to the first card on the
// page. GuidedTour silently drops any step whose target is absent or hidden.

// Kendo's PanelBarItem does not pass data-* attributes through to the DOM, so the whole
// accordion section (the li that includes the "Monthly Payment" / "Down Payment" title bar)
// is resolved by walking up from the anchor inside it. Joyride spotlights and scrolls to
// this element while the tooltip stays on `target`.
// Falls back to the anchor itself if the Kendo class ever changes, so the spotlight
// shrinks to the slider instead of the scroll jumping to a null target.
const panelSection = (anchorSelector: string) => (): HTMLElement | null => {
  const anchor = document.querySelector<HTMLElement>(anchorSelector);
  return anchor?.closest<HTMLElement>('.k-panelbar-item') ?? anchor ?? null;
};

export function getCuratedSiteTourSteps(welcomeMessage: string, makeDepositButtonText: string): Step[] {
  return [
    {
      target: 'body',
      placement: 'center',
      title: 'Welcome!',
      content: welcomeMessage,
    },
    {
      target: '[data-tour="monthly-payment-filter"]',
      spotlightTarget: panelSection('[data-tour="monthly-payment-filter"]'),
      title: 'Monthly Payment',
      content: 'Adjust your monthly payment',
    },
    {
      target: '[data-tour="down-payment-filter"]',
      spotlightTarget: panelSection('[data-tour="down-payment-filter"]'),
      title: 'Down Payment',
      content: 'Adjust your down payment',
    },
    {
      target: '[data-tour="make-deposit-button"]',
      // Spotlight the button, but scroll to the top of its card so the whole
      // vehicle (title, price, photo) stays visible behind the tooltip.
      scrollTarget: '[data-tour="vehicle-card"]',
      title: makeDepositButtonText,
      content: `Reserve your trailer from your phone`,
    },
  ];
}
